.host {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10;
  background-color: var(--color-semantic-surface-neutral50);
}

.content {
  position: absolute;
  top: 50%;
  left: 50%;
  padding: 3.2rem 3.2rem 5.6rem;
  background-color: var(--color-white);
  border-radius: 2rem;
  transform: translate(-50%, -50%);
  animation: fadeUp 0.25s ease-in-out forwards;
}

.header {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  padding-bottom: 1.4rem;
}

.title {
  margin: 0 auto;
  color: var(--color-semantic-text-neutral30);
  font-weight: bold;
  font-size: 1.8rem;
  line-height: 2.2rem;
}

.description {
  display: flex;
  justify-content: center;
  margin-top: -0.6rem;
}

.closeBtn {
  position: absolute;
  top: 3.2rem;
  right: 3.2rem;
  width: 1.4rem;
  height: 1.4rem;
  cursor: pointer;
}

.closeBtn:before,
.closeBtn:after {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 0.24rem;
  background-color: var(--color-semantic-text-neutral30);
  content: '';
}

.closeBtn::before {
  transform: translate(-50%, -50%) rotate(-45deg);
}

.closeBtn::after {
  transform: translate(-50%, -50%) rotate(45deg);
}

@keyframes fadeUp {
  from {
    transform: translate(-50%, calc(-50% + 1rem));
    opacity: 0;
  }

  to {
    transform: translate(-50%, -50%);
    opacity: 1;
  }
}
